'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = style;

var _glamorReact = require('glamor-react');

var _colors = require('../styles/colors');

var _flex = require('../styles/flex');

var _flex2 = _interopRequireDefault(_flex);

var _helpers = require('../styles/helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function style() {
  var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _colors.COLORS.CHARCOAL;

  return (0, _glamorReact.css)((0, _colors.background)(color), (0, _helpers.size)('80%'), (0, _flex2.default)({ direction: 'column' }), (0, _helpers.padding)(0, '10%'));
}


//////////////////
// WEBPACK FOOTER
// ./~/tanda-components/Container/styles.js
// module id = 1581
// module chunks = 0